import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation ,useNavigate } from 'react-router-dom';

export default function AISearch() {
  const [query, setQuery] = useState('');
  const [items, setItems] = useState([]);
  const [responseText, setResponseText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [siteName, setSiteName] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/config/siteName')
      .then(res => res.json())
      .then(data => setSiteName(data.siteName))
      .catch(err => console.error(err));
  }, []);

  // Set document title
  useEffect(() => {
    document.title = "AI Search";
  }, []);

  useEffect(() => {
      // Check for query in URL search parameters (?queryText=...)
      const searchParams = new URLSearchParams(location.search);
      var urlQuery = searchParams.get('queryText');
      if (urlQuery && urlQuery.startsWith('---')){
          urlQuery=null;
      }
      // Check for query in location.state (passed from internal navigation)
      const stateQuery = location.state && location.state.query;

      // Prioritize URL parameter if present, otherwise use state query
      const incoming = urlQuery || stateQuery;

      if (incoming) {
        setQuery(incoming);
        doSearch(incoming);
        // Clear state and URL parameters after use to prevent re-triggering on refresh
        navigate(location.pathname, { replace: true, state: {} });
      }
     // eslint-disable-next-line
  }, [location.state, location.search]);

  const doSearch = useCallback(async (query) => {
      if (!query) return;
         setLoading(true);
         setError(null);
         try {
           const res = await fetch('/api/search', {
             method: 'POST',
             headers: { 'Content-Type': 'application/json' },
             body: JSON.stringify({ query })
           });
           if (!res.ok) throw new Error('Network response was not ok');
           const data = await res.json(); // предполагается массив
           setResponseText(data.answerText);
           setItems(data.resultData);
         } catch (err) {
           setError(err.message || 'Error loading');
         } finally {
           setLoading(false);
         }
    }, []);
  const fetchItems = async (e) => {
    e && e.preventDefault();
    doSearch(query);
  };

  const truncateText = (html, maxLength) => {
    if (!html) return '';
    // Replace content of image and table tags with an empty string
    let cleanText = html.replace(/<img[^>]*>/g, '').replace(/<table[^>]*>[\s\S]*?<\/table>/g, '');
    // Replace all other HTML tags with an empty string
    cleanText = cleanText.replace(/<[^>]+>/g, '');
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + '...';
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 20,        backgroundColor: 'black',
        color: 'gold' }}>
        <div style={{ marginTop: 10 }}>
            <Link style={{ textDecoration: 'none', color: 'green'}} to="/">← Go to site sections</Link>
        </div>
        <h1>Describe your problem</h1>
      <form onSubmit={fetchItems} style={{ marginBottom: 20 }}>
        <input
          type="text"
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder="Describe your problem"
          style={{ padding: 8, width: '70%', marginRight: 8 }}
        />
        <button type="submit" style={{ padding: '8px 16px' }}>Ask a question</button>
      </form>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {responseText && (
        <div style={{ marginTop: 20, padding: 15, background: '#f5f5f5', borderRadius: 8 }}>
          <h3>Answer:</h3>
          <p>{responseText}</p>
        </div>
      )}
      {items.length > 0 && (
          <div style={{ marginTop: 20 }}>
          <h3>Found articles ({items.length}):</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
              {items.map((it, idx) => (
                  <li key={idx} style={{ marginBottom: 10, padding: 10, border: '1px solid #ddd', borderRadius: 4 }}>
                    <Link to={`/article/${it.id}`}
                          style={{ textDecoration: 'none', color: 'green'}}
                          state={{ prevQuery: query }}
                     >
                        <h4>Read full article "{it.title}"</h4>
                    </Link>
                    {it.longText && <div style={{ whiteSpace: 'pre-wrap' }}>{truncateText(it.longText, 300)}</div>}
                  </li>
              ))}
          </ul>
        </div>
        )
      }
  </div>
     )
}
